import { config } from '../../config/config';
import { Observable } from 'rxjs';
import { utilService } from '../utils';

export const unitsService = {
  getUnits,
};

function getUnits(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.course_units + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
